import type { CreateEventRequest, EventParticipant, UpdateEventRequest, UpdateParticipantRequest } from '@/api/eventsApi'

export function resultLabel(value: unknown): string { return value == null ? '' : typeof value === 'string' ? value : JSON.stringify(value) }
export function eventUpdatePayload(req: CreateEventRequest): UpdateEventRequest {
  return { ...req, clear_end_date: !req.end_date, clear_payment_amount: !req.payment_amount?.trim() }
}
/** Omission preserves any structured result. An explicit empty string clears it. */
export function participantUpdatePayload(participant: EventParticipant, status: EventParticipant['status'], payment: EventParticipant['payment_status'], result: string): UpdateParticipantRequest {
  return { status, payment_status: payment, ...(result !== resultLabel(participant.result) ? { result } : {}) }
}
